import { useEffect, useState } from "react";

//MUI IMPORTS
import { Container, Button, Paper, Box, Stack } from "@mui/material";
import { Save } from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

//CUSTOM IMPORTS
import { getData, getDataIx0 } from "../../../../services/library";
import { UrlApi } from "../../../../services/apirest";
import { logEventos } from "../../../../services/services";
import TitleUploaded from "../../../TitleUploaded";
import Notify from "../../../Notify";
import FormComprobanteArca from "./FormComprobanteArca";
import { AdjuntoField, AdjuntoFileCard } from "../../../Form/AdjuntoField";
import { DownloadFiles, ViewUploadFile } from "../../../../services/DownloadFiles";
import DialogoNuevoProveedor from "../altacomprobantes/DialogoNuevoProveedor";
import DialogOCS from "../altacomprobantes/DialogOCS";
// import ErrorDialog from "../../../Dialogs/ErrorDialog";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import InfoDialog from "../../../Dialogs/InfoDialog"
import { armarNroComprobante, esComprobanteBanco } from "../functions";

// suc_auth es la lista de sucursales que el admin habilita por usuario. Se lee en crudo de
// localStorage, donde un null del backend llega como el string "null", de ahi el parseo defensivo
// y el fallback a la sucursal propia del usuario.
const idsSucursalesHabilitadas = () => {
  const parsear = (crudo) =>
    (crudo || "")
      .split(",")
      .map((valor) => Number(valor.trim()))
      .filter((id) => Number.isInteger(id) && id > 0);

  const autorizadas = parsear(localStorage.getItem("suc_auth"));
  return autorizadas.length ? autorizadas : parsear(localStorage.getItem("sucursal"));
};

export default function AddComprobantesArca(props) {
  /* ----------------------------ESTADOS Y REFS-------------------------------  */
  //Estados para datos referencia
  const [tiposComprobantes, settiposComprobantes] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [imputaciones, setImputaciones] = useState();
  const [imputacionProveedor, setimputacionProveedor] = useState();
  const [sucursales, setSucursales] = useState();
  const [condicionesPago, setcondicionesPago] = useState();
  const [valorPorcentajes, setvalorPorcentajes] = useState([]);
  const [uuid, setuuid] = useState(uuidv4());
  const [otrostributos, setotrosTributos] = useState();
  const [impuestos, setimpuestos] = useState();
  const [tipoMoneda, settipoMoneda] = useState();
  const [empresas, setEmpresas] = useState();
  const [bancos, setBancos] = useState([]);
  // const [ordenes, setOrdenes] = useState([]);
  // const [periodos, setPeriodos] = useState();

  //Estados para datos del formulario o cálculos
  const [proveedorSelected, setproveedorSelected] = useState(null);
  const [datosCabecera, setdatosCabecera] = useState({
    id_tipocomprobante: null,
    id_proveedor: null,
    id_condicionpago: null,
    id_imputacion: null,
    id_sucursal: parseInt(localStorage.getItem("sucursal")) || null,
    comprobante_pv: "",
    comprobante_nro: "",
    id_banco: null,
    concepto: "",
    fecha_factura: null,
    // id_periodocontable: null,
    vto_factura: null,
    observaciones: null,
    id_tipomoneda: 83,
    tipo_cambio: null,
    total: 0,
    uuid_comprobante: uuid,
    id_estado: 136,
    usuario: localStorage.getItem("user"),
    cuit: proveedorSelected?.cuit || "",
    id_empresa: null,
    neto_gravado: 0,
    otros_tributos: 0
  });

  const [datosCuerpo, setdatosCuerpo] = useState([
    {
      subtotal: null,
      subtotal_iva: null,
      id_porcentajeiva: 1,
      detalle_productos: null,
      uuid_comprobante: uuid,
      usuario: localStorage.getItem("user"),
    },
  ]);

  const [datosImpuestos, setdatosImpuestos] = useState([
    {
      id_impuesto: 5,
      detalle: null,
      importe: null,
      uuid_comprobante: uuid,
      usuario: localStorage.getItem("user"),
    },
  ]);

  const [datosPie, setdatosPie] = useState([
    {
      // importe_neto_gr: null,
      id_porcentajeiva: null,
      // otros_tributos: null,
      uuid_comprobante: uuid,
      usuario: localStorage.getItem("user"),
      importe: null,
    },
  ]);

  const [guardarImputacProveedor, setGuardarImputacProveedor] = useState(false); //Este estado va a indicar si el backend debe guardar la imputacion seleccionada del gasto, en el proveedor (en caso de que no la tenga).
  const [comprobanteSelected, setcomprobanteSelected] = useState("");
  const [total, setTotal] = useState();
  const [ocsSelected, setOcsSelected] = useState([]);
  const [totalMuestro, setTotalMuestro] = useState();
  const [calcularSubtotalIva, setCalcularSubtotalIva] = useState(true);
  const [saldonoaplic, setsaldonoaplic] = useState();
  const [neto, setnetoGravado] = useState();
  const [comprobanteExiste, setcomprobanteExiste] = useState([]);
  const [saldoNegativo, setSaldoNegativo] = useState();
  const [montoMaximoSinOC, setMontoMaximoSinOC] = useState();
  const [adjuntos, setAdjuntos] = useState([]);
  const [cargandoAdjunto, setCargandoAdjunto] = useState(false);
  const [errorAdjunto, setErrorAdjunto] = useState("");
  const [showAddProveedor, setShowAddProveedor] = useState(false);
  const [showAddOC, setShowAddOC] = useState(false);
  const [muestroDiferencia, setmuestroDiferencia] = useState();
  const [idArcaImportado, setIdArcaImportado] = useState(null);
  const [showInfoDialog, setShowInfoDialog] = useState({ open: false, title: "Importante", message: "", buttonLabel: "Aceptar", onClose: () => setShowInfoDialog({ open: false }) });
  //Estados que manejan componentes visuales
  const [loading, setLoading] = useState(false);
  const [disbtn, setdisbtn] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  /* --------------------------- HANDLERS --------------------------------  */
  const handleOnChangeTotal = (e) => {
    setTotal(
      parseFloat(
        e.target.value
          .replace(/\./g, "")  // borro ptos
          .replace(/,/g, ".")  // reermplazo comas x pto
      )
    );
    setTotalMuestro(formatNumber(e.target.value))
  };

  const limpiarNumero = (valor) => {
    if (!valor) return 0;

    const numerico = String(valor)
      .replace(/\./g, "")
      .replace(",", ".");

    return parseFloat(numerico) || 0;
  };

  const handleAddProveedor = () => {
    setShowAddProveedor(true)
  };

  const handleCloseAddProveedor = async (idNuevoProveedor) => {
    setShowAddProveedor(false)
    if (!!idNuevoProveedor) {
      await fetch(`${UrlApi}/proveedores/byid/${idNuevoProveedor}`)
        .then((data) => data.json())
        .then((data) => setproveedorSelected(data[0]))
    }
    getData("/imputacion_gastos", setImputaciones);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validarFormulario()) return;
    setdisbtn(true);

    if ((formatoCalculo(saldonoaplic) > 1) || saldoNegativo) {
      alert(formatoCalculo(saldonoaplic) > 1 ? "Hay saldo sin aplicar" : "Hay saldo negativo.")
      setdisbtn(false)
      return;
    }

    const netoLimpio = limpiarNumero(neto);
    const otrosTrib = limpiarNumero(otrostributos)

    const esCredito = comprobanteSelected && comprobanteSelected.c_credito === -1;

    let adjustedTotal = total * (esCredito ? -1 : 1);

    const cuerpo = datosCuerpo.map((item) => ({
      subtotal: formatoCalculo(item.subtotal) * (esCredito ? -1 : 1),
      subtotal_iva: parseFloat((formatoCalculo(item.subtotal_iva) * (esCredito ? -1 : 1)).toFixed(2)),
      id_porcentajeiva: item.id_porcentajeiva,
      id_imputacion: item.id_imputacion, //se agrega la imputacion a cada linea
      detalle_productos: item.detalle_productos,
      uuid_comprobante: uuid,
      usuario: localStorage.getItem("user"),
      monto_iva: limpiarNumero(item.monto_iva) * (esCredito ? -1 : 1)
    }));


    const listaImputaciones = [...new Set(datosCuerpo.map(i => i.id_imputacion).filter(id => id))];

    const impuestos = datosImpuestos.filter((item) => (!!item.importe && formatoCalculo(item?.importe)) > 0).map((item) => ({
      id_impuesto: item.id_impuesto,
      detalle: item.detalle,
      importe: formatoCalculo(item.importe) * (esCredito ? -1 : 1),
      //  importe: formatoCalculo(item?.importe) < 0 ? formatoCalculo(item.importe) * (esCredito ? -1 : 1) : null,
      uuid_comprobante: uuid,
      usuario: localStorage.getItem("user"),
    }));

    const pie = datosPie.map((item, index) => {
      return {
        uuid_comprobante: uuid,
        id_porcentajeiva: item.id_porcentajeiva,
        importe: item.importe * (esCredito ? -1 : 1), // Total de la línea (Neto + IVA)
        usuario: localStorage.getItem("user"),
      };
    });

    const esBanco = esComprobanteBanco(comprobanteSelected);
    const fechaFactura = esBanco
      ? moment().format("YYYY-MM-DD")
      : datosCabecera.fecha_factura;

    const cabecera = {
      cuit_proveedor: proveedorSelected.cuit,
      id_tipocomprobante: comprobanteSelected.id || comprobanteSelected.id_tipo_comprobante,
      id_condicionpago: datosCabecera.id_condicionpago,
      id_proveedor: proveedorSelected.id, // Aseguramos que el ID del proveedor vaya en la cabecera
      id_sucursal: datosCabecera.id_sucursal,
      nro_comprobante: armarNroComprobante(comprobanteSelected, datosCabecera),
      fecha_factura: fechaFactura,
      vto_factura: moment(datosCabecera.vto_factura).format("YYYY-MM-DD"),
      observaciones: datosCabecera.observaciones,
      id_tipomoneda: datosCabecera.id_tipomoneda,
      tipo_cambio: datosCabecera.tipo_cambio,
      total: adjustedTotal,
      uuid_comprobante: uuid,
      id_estado: 136,
      usuario: localStorage.getItem("user"),
      id_empresa: datosCabecera.id_empresa, 
      neto_gravado: netoLimpio * (esCredito ? -1 : 1),
      otros_tributos: otrosTrib * (esCredito ? -1 : 1),
      ...(esBanco && {
        id_banco: datosCabecera.id_banco,
        concepto: datosCabecera.concepto,
      }),
    };

    const requestData = {
      ocsSelected: total > montoMaximoSinOC.valor ? ocsSelected : [],
      datosCabecera: cabecera,
      datosCuerpo: cuerpo,
      datosImpuestos: impuestos,
      datosPie: pie,
      guardarImputacionEnProveedor: guardarImputacProveedor,
      listaImputacionesAAsociar: listaImputaciones, // <--- ENVIAMOS LA LISTA AL BACKEND
      ...(idArcaImportado != null && { id_arca_importado: idArcaImportado }),

      ...(proveedorSelected?.padron === 1 && {
        nuevoProveedor: {
          ...proveedorSelected,
          id_condicionventa: cabecera.id_condicionpago,
          usuario: localStorage.getItem("user"),
          observaciones: "Proveedor cargado en carga de comprobantes.",
        },
      }),
    };

    try {
      // console.log("requestData", requestData)
      const res = await fetch(UrlApi + "/comprobantes_cabecera/anade_proveedor", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (!res.ok) {
        alert("No se pudo guardar el comprobante.");
        setdisbtn(false);
        return;
      }

      setNotificacion({
        open: true,
        mensaje: "Comprobante Guardado Exitosamente",
        severity: "success",
        color: "#D4EFDF",
        handleClose: () => {
          props.alta(false);
          props.tabla(true);
        }
      });
    } catch (error) {
      console.error("Error al guardar los datos:", error);
      alert("Hubo un error al guardar los datos");
      setdisbtn(false);
    }
  }

  const handleCloseNotificacion = () => {
    setNotificacion({ ...notificacion, open: false });
  };

  /* --------------------------- HELPERS (Calculan o deciden algo) --------------------------------  */
  const formatNumber = (value) => {
    if (!value) return "";

    value = value?.replace(/[^\d,]/g, "");

    if (/^\d+(,)?$/.test(value)) {
      const numeric = value.replace(",", "");
      const formatted = numeric.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return value.endsWith(",") ? formatted + "," : formatted;
    }

    const [integerPart, decimalPart] = value.split(",");
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return decimalPart !== undefined
      ? `${formattedInteger},${decimalPart}`
      : formattedInteger;
  };

  const formatoCalculo = (valor) => {
    return parseFloat(valor.replace(/\./g, "")?.replace(/,/g, "."));
  }

  const validarFormulario = () => {
    const errors = [];
    if (!proveedorSelected)
      errors.push("Es necesario seleccionar un proveedor.");
    if (!comprobanteSelected)
      errors.push("Es necesario seleccionar un comprobante");
    if (!datosCabecera.id_condicionpago)
      errors.push("Es necesario seleccionar una condición de venta");
    // if (!datosCabecera.id_imputacion)
    //   errors.push("Es necesario seleccionar una imputación");
    if (!datosCabecera.id_sucursal)
      errors.push("Es necesario seleccionar una sucursal");

    const esBanco = esComprobanteBanco(comprobanteSelected);

    if (esBanco) {
      if (!datosCabecera.id_banco)
        errors.push("Es necesario seleccionar un banco");
      if (!datosCabecera.concepto?.trim())
        errors.push("Es necesario ingresar el concepto del movimiento bancario");
    } else {
      if (!datosCabecera.comprobante_pv)
        errors.push("Es necesario ingresar el punto de venta del comprobante");
    }

    if (!datosCabecera.comprobante_nro)
      errors.push("Es necesario ingresar el numero del comprobante");
    if (!total)
      errors.push("Es necesario ingresar el importe TOTAL del comprobante");

    if (!esBanco && !datosCabecera.fecha_factura)
      errors.push("Es necesario seleccionar una fecha de comprobante");
    if (datosCabecera.id_tipomoneda !== 83 && !datosCabecera.tipo_cambio)
      errors.push("Es necesario ingresar un tipo de cambio");


    // if (!periodoSelected) errors.push("Es necesario seleccionar un periodo contable.");
    // Validaciones del cuerpo (dinámico)
    datosCuerpo.forEach((item, index) => {
      if (!item.subtotal)
        errors.push(`Fila ${index + 1}: Es necesario ingresar un importe neto en la linea.`);
      if (!item.subtotal_iva)
        errors.push(
          `Fila ${index + 1}: Es necesario ingresar el subtotal CON IVA`
        );
      if (!item.id_porcentajeiva)
        errors.push(
          `Fila ${index + 1}: Es necesario seleccionar un porcentaje de IVA`
        );
      if (!item.detalle_productos)
        errors.push(
          `Fila ${index + 1}: Es necesario ingresar una descripcion en el de producto`
        );
    });

    // Validaciones del cuerpo (dinámico)
    datosImpuestos.forEach((item, index) => {
      // if (!item.detalle && !!item.importe)
      //   errors.push(`Fila ${index + 1}: Es necesario detallar el impuesto.`);
      if (!item.importe && !!item.detalle)
        errors.push(
          `Fila ${index + 1}: Es necesario ingresar el importe del impuesto`
        );
    });

    if (errors.length) {
      setNotificacion({
        open: true,
        mensaje: errors[0],
        severity: "error",
        color: "#FADBD8",
      });
      return false;
    }
    return true;
  };

  /* --------------------------- FETCHS --------------------------------  */
  const getProveedores = async (busqueda) => {
    if (!busqueda) return;

    setLoading(true);

    try {
      const res = await fetch(
        UrlApi + `/proveedores_padron/search?query=${encodeURIComponent(busqueda)}`
      );
      const data = await res.json();
      setProveedores(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  /* --------------------------- EFFECTS --------------------------------  */
  useEffect(() => {
    if (props.empresaFija?.id != null) {
      // Modo ARCA: los tipos salen de tipos_comprobantes (FK real de comprobantes.id_tipocomprobante);
      // se normaliza id → id_tipo_comprobante para reutilizar el resto del form sin cambios.
      fetch(UrlApi + "/tipos_comprobantes")
        .then((r) => r.json())
        .then((d) =>
          settiposComprobantes(
            (Array.isArray(d) ? d : []).map((t) => ({ ...t, id_tipo_comprobante: t.id }))
          )
        )
        .catch((e) => console.error("Error tipos_comprobantes:", e));
    } else {
      getData("/facturacion_tipos_comprobantes", settiposComprobantes);
    }
    getData("/sucursales", (data) => {
      const habilitadas = idsSucursalesHabilitadas();
      setSucursales(
        (Array.isArray(data) ? data : []).filter((suc) =>
          habilitadas.includes(Number(suc.id))
        )
      );
    });
    getData("/impuestos", setimpuestos);
    getData("/porcentaje_iva", setvalorPorcentajes);
    getData("/condicion_pago", setcondicionesPago);
    getData("/desplegables/tipoMoneda", settipoMoneda);
    // getData('/periodo_contable', setPeriodos)
    getDataIx0('/desplegables/montoMaximoFactura', setMontoMaximoSinOC)
    getData('/empresas', setEmpresas)
    getData('/bancos', setBancos)
  }, []);

  useEffect(() => {
    if (props.empresaFija?.id != null) {
      setdatosCabecera((prev) => ({ ...prev, id_empresa: props.empresaFija.id }));
      const usuario = localStorage.getItem("user");
      // Modo ARCA: 3 líneas fijas de percepciones (Perc. IVA / IIBB / Otros)
      setdatosImpuestos([
        { id_impuesto: 5, importe: null, uuid_comprobante: uuid, usuario },
        { id_impuesto: null, importe: null, uuid_comprobante: uuid, usuario },
        { id_impuesto: 28, importe: null, uuid_comprobante: uuid, usuario },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.empresaFija?.id]);

  // Modo ARCA: al "Cargar" un pendiente, precargar la clave (PV/Nº + proveedor) desde la fila
  useEffect(() => {
    const fila = props.filaArca;
    if (!fila) return;
    setdatosCabecera((prev) => ({
      ...prev,
      comprobante_pv: fila.punto_venta ?? "",
      comprobante_nro: fila.nro_desde ?? "",
    }));
    if (fila.cuit_emisor) {
      fetch(UrlApi + `/proveedores_padron/search?query=${fila.cuit_emisor}`)
        .then((r) => r.json())
        .then((list) => {
          const prov = Array.isArray(list)
            ? list.find((p) => String(p.cuit) === String(fila.cuit_emisor)) || list[0]
            : null;
          if (!prov) return;
          setproveedorSelected(prov);
          setdatosCabecera((prev) => ({
            ...prev,
            id_proveedor: prov.padron === 1 ? null : prov.id,
            id_condicionpago: prov.id_condicionventa || prev.id_condicionpago,
          }));
          getData("/imputacion_gastos", setImputaciones);
        })
        .catch((e) => console.error("Error precarga proveedor ARCA:", e));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.filaArca]);

  // Modo ARCA manual (sin fila del CSV): precargar lo que el usuario tipeó en la búsqueda
  // (CUIT → proveedor, PV, Nº, fecha). No bloquea nada: bloqueoArca requiere filaArca.
  useEffect(() => {
    const pf = props.prefillManual;
    if (!pf || props.filaArca) return;
    setdatosCabecera((prev) => ({
      ...prev,
      comprobante_pv: pf.pv || prev.comprobante_pv,
      comprobante_nro: pf.nro || prev.comprobante_nro,
      fecha_factura: pf.fecha || prev.fecha_factura,
    }));
    if (pf.cuit) {
      fetch(UrlApi + `/proveedores_padron/search?query=${pf.cuit}`)
        .then((r) => r.json())
        .then((list) => {
          const prov = Array.isArray(list)
            ? list.find((p) => String(p.cuit) === String(pf.cuit)) || list[0]
            : null;
          if (!prov) return;
          setproveedorSelected(prov);
          setdatosCabecera((prev) => ({
            ...prev,
            id_proveedor: prov.padron === 1 ? null : prov.id,
            id_condicionpago: prov.id_condicionventa || prev.id_condicionpago,
          }));
          getData("/imputacion_gastos", setImputaciones);
        })
        .catch((e) => console.error("Error precarga manual ARCA:", e));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.prefillManual]);

  // Modo ARCA: preseleccionar el Tipo de comprobante desde el código ARCA de la fila
  useEffect(() => {
    const fila = props.filaArca;
    if (!fila || !tiposComprobantes?.length) return;
    const t = tiposComprobantes.find(
      (x) => Number(x.codigo) === Number(fila.tipo_comprobante_arca)
    );
    if (t) setcomprobanteSelected(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.filaArca, tiposComprobantes]);

  useEffect(() => {
    if (esComprobanteBanco(comprobanteSelected)) {
      setdatosCabecera((prev) => ({
        ...prev,
        fecha_factura: moment().format("YYYY-MM-DD"),
        comprobante_pv: "",
      }));
    }
  }, [comprobanteSelected]);

  const getAdjuntos = () => {
    fetch(UrlApi + "/uploadfiles/todownload/" + uuid)
      .then((res) => res.json())
      .then((data) => setAdjuntos(Array.isArray(data) ? data : []))
      .catch(() => setAdjuntos([]));
  };

  useEffect(() => {
    getAdjuntos();
  }, [uuid]);

  const handleAdjuntoChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;

    setCargandoAdjunto(true);
    setErrorAdjunto("");
    const data = new FormData();
    data.append("uid", uuid);
    data.append("archivo", file);

    try {
      const res = await fetch(UrlApi + "/uploadfiles/uploadfiles", {
        method: "POST",
        body: data,
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(body?.message || "No se pudo cargar el archivo");
      }
      setNotificacion({
        open: true,
        mensaje: body?.message || "Archivo cargado",
        severity: "success",
        color: "",
      });
      getAdjuntos();
    } catch (err) {
      setErrorAdjunto(err.message || "No se pudo cargar el archivo");
    } finally {
      setCargandoAdjunto(false);
    }
  };

  const quitarAdjunto = async (archivo) => {
    if (!window.confirm("Usted está por eliminar el archivo: " + archivo.nombre)) return;

    try {
      const res = await fetch(UrlApi + "/uploadfiles/todownload/" + archivo.id, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      });
      if (!res.ok) {
        setErrorAdjunto("No se borro el archivo");
        return;
      }
      setErrorAdjunto("");
      setNotificacion({
        open: true,
        mensaje: "Archivo borrado",
        severity: "success",
        color: "",
      });
      getAdjuntos();
    } catch (err) {
      setErrorAdjunto("No se borro el archivo");
    }
  };

  useEffect(() => {
    if (comprobanteSelected) {
      const nuevoIva = comprobanteSelected.id_tipo_comprobante === 11 ? 4 : 1;

      setdatosCuerpo((prevDatos) =>
        prevDatos.map((item) => ({
          ...item,
          id_porcentajeiva: nuevoIva,
        }))
      );
    }
  }, [comprobanteSelected]);

  const handleOnBlurTotal = () => {
    if ((total > montoMaximoSinOC.valor) && ocsSelected.length === 0) {
      setShowInfoDialog({
        open: true, message: "El total del comprobante supera el monto máximo permitido sin orden de compra. Debe vincularse a una orden de compra.", title: "Importante", buttonLabel: "Aceptar", onClose: () => {
          setShowInfoDialog({ open: false })
          setShowAddOC(true)
        }
      })
    } else if ((!total || montoMaximoSinOC.valor >= total) && ocsSelected.length > 0) {
      setShowInfoDialog({
        open: true, message: "El total del comprobante no supera el monto máximo permitido sin orden de compra o fue eliminado. No se asociará ninguna orden de compra.", title: "Importante", buttonLabel: "Aceptar", onClose: () => {
          setShowInfoDialog({ open: false })
        }
      })

      setOcsSelected([]);
    }
  }

  //   const handleOnBlurMontoMaximo = () => {
  //   if (datosCabecera.id_tipomoneda === 82 || datosCabecera.id_tipomoneda === 84) {
  //     const totalConvertido = total * (datosCabecera.tipo_cambio * 1);
  //     if (totalConvertido > montoMaximoSinOC.valor && ocsSelected.length === 0) {
  //       setShowInfoDialog({
  //         open: true,
  //         message:
  //           "El total del comprobante supera el monto máximo permitido sin orden de compra. Debe vincularse a una orden de compra.",
  //         title: "Importante",
  //         buttonLabel: "Aceptar",
  //         onClose: () => {
  //           setShowInfoDialog({ open: false });
  //           setShowAddOC(true);
  //         },
  //       });
  //     }
  //   }
  // };

  /* --------------------------- BLOQUEO ARCA --------------------------------  */
  // Modo ARCA con una fila importada: los datos que trae el CSV quedan de solo-lectura.
  // Compras solo edita lo que el archivo no aporta (condición de pago, imputación,
  // descripción de líneas, percepciones). El proveedor se bloquea únicamente si ARCA ya lo
  // adjudicó por CUIT; si la fila quedó "sin proveedor", Compras debe poder elegirlo.
  const bloqueoArca = props.empresaFija?.id != null && !!props.filaArca;
  const _falta = props.filaArca?.falta;
  const proveedorAdjudicado =
    _falta && typeof _falta === "object"
      ? !_falta.proveedor
      : props.filaArca?.id_proveedor != null ||
        props.filaArca?.estado === "completo";
  const bloqueoProveedorArca = bloqueoArca && proveedorAdjudicado;

  /* --------------------------- STYLING --------------------------------  */
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#1f618d",
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#1f618d",
    },
  };

  /* --------------------------- RENDER --------------------------------  */
  return (
    <div
      style={{
        minHeight: "90vh",
      }}
    >
      {notificacion.open && (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={notificacion.handleClose || handleCloseNotificacion}
          severity={notificacion.severity}
        />
      )
      }
      <Container maxWidth="xl" sx={{ pt: 0, pb: 10 }}>
        <TitleUploaded
          pt={0}
          title={props.empresaFija?.id != null ? "Cargar comprobante" : "Cargar nuevo comprobante"}
          handleClose={() => [props.alta(false), props.tabla(true)]}
        />
        <FormComprobanteArca
          loading={loading}
          formatNumber={formatNumber}
          formatoCalculo={formatoCalculo}
          proveedores={proveedores}
          tiposComprobantes={tiposComprobantes}
          sucursales={sucursales}
          impuestos={impuestos}
          tipoMoneda={tipoMoneda}
          condicionesPago={condicionesPago}
          valorPorcentajes={valorPorcentajes}
          imputaciones={imputaciones}
          setImputaciones={setImputaciones}
          setotrosTributos={setotrosTributos}
          otrostributos={otrostributos}
          datosCabecera={datosCabecera}
          setdatosCabecera={setdatosCabecera}
          setdatosCuerpo={setdatosCuerpo}
          datosCuerpo={datosCuerpo}
          datosImpuestos={datosImpuestos}
          setdatosImpuestos={setdatosImpuestos}
          datosPie={datosPie}
          setdatosPie={setdatosPie}
          proveedorSelected={proveedorSelected}
          setproveedorSelected={setproveedorSelected}
          comprobanteSelected={comprobanteSelected}
          setcomprobanteSelected={setcomprobanteSelected}
          calcularSubtotalIva={calcularSubtotalIva}
          setCalcularSubtotalIva={setCalcularSubtotalIva}
          total={total}
          setTotal={setTotal}
          comprobanteExiste={comprobanteExiste}
          setcomprobanteExiste={setcomprobanteExiste}
          setnetoGravado={setnetoGravado}
          neto={neto}
          saldonoaplic={saldonoaplic}
          saldoNegativo={saldoNegativo}
          setSaldoNegativo={setSaldoNegativo}
          setsaldonoaplic={setsaldonoaplic}
          style={style}
          setdisbtn={setdisbtn}
          validarFormulario={validarFormulario}
          getProveedores={getProveedores}
          setProveedores={setProveedores}
          setGuardarImputacProveedor={setGuardarImputacProveedor}
          totalMuestro={totalMuestro}
          handleOnChangeTotal={handleOnChangeTotal}
          handleAddProveedor={handleAddProveedor}
          handleCloseAddProveedor={handleCloseAddProveedor}
          handleOnBlurTotal={handleOnBlurTotal}
          empresas={empresas}
          empresaFija={props.empresaFija}
          filaArca={props.filaArca}
          bloqueoArca={bloqueoArca}
          bloqueoProveedorArca={bloqueoProveedorArca}
          setIdArcaImportado={setIdArcaImportado}
          bancos={bancos}
          imputacionProveedor={imputacionProveedor}
          setimputacionProveedor={setimputacionProveedor}
          muestroDiferencia ={muestroDiferencia}
           setmuestroDiferencia ={ setmuestroDiferencia}
        // handleOnBlurMontoMaximo={handleOnBlurMontoMaximo}
        />
        <Paper
          elevation={3}
          sx={{
            px: 2,
            py: 1.5,
            mt: 1,
            borderRadius: 3,
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Stack spacing={1}>
              {adjuntos.map((archivo) => (
                <AdjuntoFileCard
                  key={archivo.id}
                  title="Comprobante"
                  idTipoAdjunto={archivo.id}
                  hasFile
                  fileName={archivo.nombre}
                  showDownloadAction
                  showViewAction
                  onFileChange={() => {}}
                  onRemove={() => quitarAdjunto(archivo)}
                  onView={() =>
                    ViewUploadFile(
                      `${archivo.id_archivo}-${archivo.nombre}`,
                      archivo.extension
                    )
                  }
                  onDownload={() =>
                    DownloadFiles(`${archivo.id_archivo}-${archivo.nombre}`)
                  }
                />
              ))}
              <AdjuntoField
                title="Adjuntar comprobante"
                idTipoAdjunto={0}
                loadingId={cargandoAdjunto ? 0 : null}
                hasFile={false}
                accept="*/*"
                error={errorAdjunto}
                cardProps={{
                  showRemoveAction: false,
                  showDownloadAction: false,
                }}
                onFileChange={handleAdjuntoChange}
                onRemove={() => {}}
              />
            </Stack>
          </Box>
        </Paper>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1.5, mb: 2 }}>
          <Button
            variant="contained"
            type="submit"
            disabled={disbtn}
            onClick={handleSubmit}
            startIcon={<Save />}
            sx={{
              backgroundColor: "#1f618d",
              "&:hover": { backgroundColor: "#154360" },
            }}
          >
            Guardar Comprobante
          </Button>
        </Box>
      </Container>
      {
        showAddProveedor && (
          <DialogoNuevoProveedor
            open={showAddProveedor}
            handleCloseAddProveedor={handleCloseAddProveedor}
          />)
      }
      {
        showAddOC && (
          <DialogOCS
            open={showAddOC}
            proveedor={proveedorSelected}
            ocsSelected={ocsSelected}
            setOcsSelected={setOcsSelected}
            handleCloseAddOC={() => setShowAddOC(false)}
          />
        )
      }
      {
        showInfoDialog.open && (
          <InfoDialog
            open={showInfoDialog.open}
            setOpen={setShowInfoDialog}
            title={showInfoDialog.title}
            message={showInfoDialog.message}
            buttonLabel={showInfoDialog.buttonLabel}
            onClose={showInfoDialog.onClose}
          />
        )
      }
    </div>
  );
}
